module.exports = __webpack_public_path__ + "img/create-shift.2d4d5003.svg";